import { Button } from "@/components/ui/baseUi/button"
import { InputGroup, InputGroupAddon, InputGroupInput } from "@/components/ui/baseUi/input-group"
import { cn } from "@/modules/lib/utils"
import { BoxOfferCard } from "@modules/boxOffer/components/boxOfferCard"
import { BoxOfferItemEntity } from "@modules/boxOffer/entities/boxOfferEntity"
import { StatusFilter } from "@modules/boxOffer/gateway/boxOfferDto"
import { useBoxOffers } from "@modules/boxOffer/hooks/useBoxOffer"
import { word } from "@modules/core/utils/i18n"
import { Search, X } from "lucide-react"
import { useMemo, useState } from "react"

export type MemberSendOfferModalStepOneProps = {
  selectedOffer: BoxOfferItemEntity | null
  setSelectedOffer: (offer: BoxOfferItemEntity | null) => void
  handleStep: () => void
  onHide: () => void
  className?: string
} & React.ComponentProps<"div">

export const MemberSendOfferModalStepOne: React.FC<MemberSendOfferModalStepOneProps> = ({
  selectedOffer,
  setSelectedOffer,
  handleStep,
  onHide,
  className,
  ...props
}) => {
  const { data: offers } = useBoxOffers({ statusFilter: StatusFilter.ACTIVE })
  const [researchFilter, setGlobalFilter] = useState("")

  const filteredOffers = useMemo(() => {
    return offers.filter(
      (offer) =>
        offer.name.toLowerCase().indexOf(researchFilter.toLowerCase()) >= 0 ||
        (offer.description && offer.description.toLowerCase().indexOf(researchFilter.toLowerCase()) >= 0),
    )
  }, [researchFilter, offers])

  return (
    <div className={cn("mt-4 flex w-full flex-col", className)} {...props}>
      {/* SEARCH BAR */}
      <InputGroup>
        <InputGroupInput
          placeholder={word("box.offer.send.modal.placeholder.inputName")}
          onChange={(e) => setGlobalFilter(e.currentTarget.value)}
          value={researchFilter}
        />
        <InputGroupAddon align="inline-start">
          <Search />
        </InputGroupAddon>
        {researchFilter && (
          <InputGroupAddon align="inline-end" onClick={() => setGlobalFilter("")}>
            <X color="currentColor" width={14} height={14} className="cursor-pointer text-textDefault-body" />
          </InputGroupAddon>
        )}
      </InputGroup>
      {/* OFFERS */}
      <div className="my-8 flex h-100 w-full flex-col gap-4 overflow-y-auto">
        {filteredOffers.length > 0 &&
          filteredOffers.map((offer) => (
            <BoxOfferCard
              offer={offer}
              key={offer.id}
              onClick={() => setSelectedOffer(offer)}
              className={`flex w-full cursor-pointer justify-between gap-6 rounded-xl border p-4 ${selectedOffer?.id === offer.id ? "border-primary-700 bg-neutral-100" : "border-borderDefault"}`}
            />
          ))}
      </div>
      {/* BUTTON */}
      <div className="flex w-full flex-row items-center justify-center gap-2">
        <Button variant="outline" size="lg" onClick={onHide} className="grow">
          {word("global.cancel")}
        </Button>

        <Button variant="primary" size="lg" onClick={handleStep} disabled={!selectedOffer} className="grow">
          {word("global.continue")}
        </Button>
      </div>
    </div>
  )
}
